/**
 * @desc 编辑
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(body: defs.esca.EChapterEditRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/eChapter/edit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
